import { renderValue } from '@thinkalpha/language-services';
import type { ConcreteDataType } from '@thinkalpha/language-services';
import {
    getAllowedArgumentValue,
    isEnumeratedOptionAllowedArgument,
} from '@thinkalpha/platform-ws-client/contracts/dictionary.js';
import type { AllowedArgument, IndicatorParameter } from '@thinkalpha/platform-ws-client/contracts/dictionary.js';
import z from 'zod';

export const makeOptionsSchema = (options: ParamOptions[]) => {
    const stringValues = options.map((opt) => opt.input);
    const schema = z.string().refine((value) => stringValues.includes(value), {
        message: `Value must be one of: ${stringValues.join(', ')}`,
    });
    return schema;
};

interface ParamOptions {
    input: string;
    value: AllowedArgument;
    description?: string;
}

export class IndicatorParamModel {
    #param: IndicatorParameter;

    #options: ParamOptions[];

    #schema: z.ZodSchema<any>;

    constructor(param: IndicatorParameter) {
        this.#param = param;

        this.#options = (param.options?.values || []).map((param) => {
            const v = getAllowedArgumentValue(param);
            let input: string;
            if (typeof v === 'string') input = v;
            else if (typeof v === 'boolean') input = `${v}`;
            else if (typeof v === 'number') input = v.toString();
            else input = renderValue(v);

            const description = isEnumeratedOptionAllowedArgument(param) ? param.description : undefined;

            return { input, value: param, description };
        });

        if (this.#options.length > 0) {
            this.#schema = makeOptionsSchema(this.#options);
        } else {
            this.#schema = z.string();
        }
    }

    get name(): string | undefined {
        return this.#param.name;
    }

    get optional(): boolean {
        return this.#param.optional;
    }

    get type(): ConcreteDataType {
        return this.#param.dataType;
    }

    get options(): ParamOptions[] {
        return this.#options;
    }

    get schema() {
        return this.#schema;
    }

    get defaultValue() {
        return this.#param.defaultValue;
    }
}
